import { Injectable } from '@angular/core';
import { MeteorUser, MeteorUserProfile } from '../../../../../backend/server/data-models/meteor-user/meteor-user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor() { }

  sendVerificationEmail(email: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return Meteor.call("meteor-user.sendVerificationEmail", email, (err, res) => {
        if (!err) {
          console.warn(res);
          resolve(true);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  get(_id: string): Promise<MeteorUser> {
    return new Promise<MeteorUser>((resolve, reject) => {
      Meteor.call("meteor-user.get", _id, (err, res: MeteorUser) => {
        // console.warn("devices.update");
        // console.warn(res);
        // console.warn(err);
        if (!err) {
          resolve(res ? new MeteorUser(res) : null);
        } else {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  updateProfile(_id: string, profile: MeteorUserProfile): Promise<MeteorUser> {
    return new Promise<MeteorUser>((resolve, reject) => {
      Meteor.call("meteor-user.updateProfile", _id, profile, (err, res: MeteorUser) => {
        // console.warn("devices.update");
        // console.warn(res);
        // console.warn(err);
        if (!err) {
          resolve(res ? new MeteorUser(res) : null);
        } else {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  create(email: string, passsword: string, profile: MeteorUserProfile): Promise<MeteorUser> {
    return new Promise<MeteorUser>((resolve, reject) => {
      Meteor.call("meteor-user.create", email, passsword, profile, (err, res: MeteorUser) => {
        // console.warn("devices.update");
        // console.warn(res);
        // console.warn(err);
        if (!err) {
          resolve(res ? new MeteorUser(res) : null);
        } else {
          // console.error(err);
          reject(err);
        }
      });
    });
  }

  delete(id: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      Meteor.call("meteor-user.delete", id, (err, res: boolean) => {
        // console.warn("devices.update");
        // console.warn(res);
        // console.warn(err);
        if (!err) {
          resolve(res);
        } else {
          // console.error(err);
          reject(err);
        }
      });
    });
  }


  getUserList(name: string = null): Promise<MeteorUser[]> {
    return new Promise<MeteorUser[]>((resolve, reject) => {
      Meteor.call("meteor-user.getUserList", false, name, (err, res: MeteorUser[]) => {
        // console.warn("devices.update");
        // console.warn(res);
        // console.warn(err);
        if (!err) {
          res.forEach((user, idx) => res[idx] = new MeteorUser(user));
          resolve(res);
        } else {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  isAdmin(user: (string | Meteor.User) = Meteor.userId()) {
    return this.isInRole('ADMIN', user);
  }

  isInRole(name: "USER" | "ADMIN", user: (string | Meteor.User) = Meteor.userId()): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      Meteor.call("meteor-user.isInRole", name, user, (err, res: boolean) => {
        // console.warn("meteor-user.isInRole");
        // console.warn(res);
        // console.warn(err);
        if (!err) {
          resolve(res);
        } else {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  getRolesForUser(user: (string | Meteor.User) = Meteor.userId()): Promise<string[]> {
    return new Promise<string[]>((resolve, reject) => {
      Meteor.call("meteor-user.getRolesForUser", user, (err, res: string[]) => {
        // console.warn("meteor-user.getRolesForUser");
        // console.warn(res);
        // console.warn(err);
        if (!err) {
          resolve(res);
        } else {
          console.error(err);
          reject(err);
        }
      });
    })
  }

  addRole(role: "USER" | "ADMIN", user: (string | Meteor.User) = Meteor.userId()): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      Meteor.call("meteor-user.addRole", role, user, (err, res: boolean) => {
        // console.warn("meteor-user.addRole");
        // console.warn(res);
        // console.warn(err);
        if (!err) {
          resolve();
        } else {
          console.error(err);
          reject(err);
        }
      });
    })
  }

  /**
   *
   * @param role only ADMIN allowed: cannot remove USER role!
   */
  removeRole(role: "ADMIN" = "ADMIN", user: (string | Meteor.User) = Meteor.userId()): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      Meteor.call("meteor-user.removeRole", role, user, (err, res: boolean) => {
        // console.warn("meteor-user.removeRole");
        // console.warn(res);
        // console.warn(err);
        if (!err) {
          resolve();
        } else {
          console.error(err);
          reject(err);
        }
      });
    })
  }

}
